<!--
    Summary:
        无创产前亲子鉴定
    ChangeLog:
        Labbor on 2020/2/22 added
-->
<template>
  <div class="v-non-invasive-prenatal-paternity-test">
    <banner>
      <img src="../../assets/images/non-invasive-prenatal-paternity-test/Header_1920x380-12.jpg"/>
      <div slot="title">{{$t('NonInvasivePrenatalPaternityTest.Title')}}</div>
    </banner>

    <div class="p1">
      <h2 class="h2" style="text-align: center; color: #cb3439; text-shadow: 1px 1px 2px #ffffff;">{{$t('NonInvasivePrenatalPaternityTest.P1Title')}}</h2>
      <p>&nbsp;</p>
      <h5 class="h5" style="text-align: center; color: #ffffff; text-shadow: 1px 1px 2px #cb3439;">{{$t('NonInvasivePrenatalPaternityTest.P1Detail')}}</h5>
    </div>

    <div class="p2">
      <img-card class="card" has-img>
        <div slot="title">{{$t('NonInvasivePrenatalPaternityTest.P2Title')}}</div>
        <img slot="img" style="margin-top: 80px;" src="../../assets/images/non-invasive-prenatal-paternity-test/無創產前親子鑑定-01.jpg"/>
        <p>{{$t('NonInvasivePrenatalPaternityTest.P2Detail')}}</p>
        <p>&nbsp;</p>
        <p>{{$t('NonInvasivePrenatalPaternityTest.P2Detail2')}}</p>
      </img-card>
    </div>

    <div class="p3">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalPaternityTest.P3Title')}}</div>
        <div class="c box-wrapper">
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-27.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_1Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_1Detail')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_1DetailHeavy')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-28.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_2Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_2Detail')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_2DetailHeavy')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-44.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_3Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_3Detail')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_3DetailHeavy')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-47.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_4Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_4Detail')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_4DetailHeavy')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-48.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_5Title')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_5Detail')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_5DetailHeavy')}}</div>
          </box>
          <box class="box" has-title has-line has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-07.png"/>
            <div slot="sub-title">{{$t('NonInvasivePrenatalPaternityTest.P3_6Title')}}</div>
            <div slot="sub-detail" v-if="$i18n.locale!='en-US'">{{$t('NonInvasivePrenatalPaternityTest.P3_6DetailHeavy')}}</div>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P3_6Detail')}}</div>
          </box>
        </div>
      </img-card>
    </div>

    <div class="p4">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalPaternityTest.P4Title')}}</div>
        <div class="c">
          <div class="left">
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/paternity-mother.jpg"/>
            <h2 style="color: #cb3439; text-align: center;font-size:26px;">{{$t('NonInvasivePrenatalPaternityTest.P4_1Title')}}</h2>
            <p style="text-align: center;">{{$t('NonInvasivePrenatalPaternityTest.P4_1Detail')}}</p>
          </div>
          <div class="right">
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/paternity-father.jpg"/>
            <h2 style="color: #cb3439; text-align: center;font-size:26px;">{{$t('NonInvasivePrenatalPaternityTest.P4_2Title')}}</h2>
            <p style="text-align: center;">
              {{$t('NonInvasivePrenatalPaternityTest.P4_2Detail')}}
            </p>
            <p style="text-align: center;" v-if="$i18n.locale=='en-US'">
              {{$t('NonInvasivePrenatalPaternityTest.P4_2Details')}}
            </p>
            <p style="text-align: center;">{{$t('NonInvasivePrenatalPaternityTest.P4_2Detail2')}}</p>
          </div>
        </div>
      </img-card>
    </div>

    <!--  适用人群  -->
    <div class="p5">
      <img-card class="card">
        <div slot="title">{{$t('NonInvasivePrenatalPaternityTest.P5Title')}}</div>

        <div class="c box-wrapper">
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-18.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P5_1Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-18.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P5_2Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-10.png"/>
            <div slot="sub-detail" :class="$i18n.locale=='en-US'?'':'letterspace'">{{$t('NonInvasivePrenatalPaternityTest.P5_3Detail')}}</div>
          </box>
          <box class="box" has-detail>
            <img src="../../assets/images/non-invasive-prenatal-paternity-test/Reproductive-health_icon-14.png"/>
            <div slot="sub-detail">{{$t('NonInvasivePrenatalPaternityTest.P5_4Detail')}}</div>
          </box>
          <box class="box">
          </box>
          <box class="box">
          </box>
        </div>
      </img-card>
    </div>

  </div>
</template>

<script>
  import banner from '@/components/banner'
  import imgCard from './img-card'
  import box from './box'
  import hoverBox from '@/components/hover-box'

  export default {
    components: {
      banner,
      imgCard,
      hoverBox,
      box
    },
    data() {
      return {}
    },
    mounted() {
    },
    methods: {},
  }
</script>
<style scoped lang="scss">
  .v-non-invasive-prenatal-paternity-test {
    text-align: left;

    .p1 {
      background-color: #e699b2;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .card {
      padding-bottom: 30px;
    }


    .box-wrapper {
      display: flex;

      & > div {
        width: 17.67%;
      }
    }

    .p3 {
      background-color: rgba(251, 207, 192, 0.2);
    }

    .p4 {
      .c {
        display: flex;
        justify-content: space-around;
        &>div{
          width: 50%;
          text-align: center;
        }
        img{
          width: 300px;
          height: 200px;
        }
      }
    }

    .p5 {
      background-color: rgba(251, 207, 192, 0.2);
    }
  }
  .v-box{
    padding:0 10px !important;
  }

  .letterspace{
    letter-spacing: 3px;;
  }
</style>



// WEBPACK FOOTER //
// src/view/genedetection/non-invasive-prenatal-paternity-test.vue